import {
	FrontendContentPage,
	TestHierarchyNodeType,
	TestStatus,
	TurnaroundTime,
} from "node-library/dist/constants";
import {
	formatAbsoluteDate,
	formatCustomDate,
} from "node-library/dist/helpers/date_helper";
import {
	FrontendAdminViewSampleWithInstanceAndSpec,
	FrontendCompanySampleMatrix,
	FrontendCompanyTestCategory,
	FrontendCompanyTestHierarchyNode,
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
	FrontendSampleTestBatch,
	FrontendSampleTestInformation,
	FrontendUserInfo,
	TestHierarchyTreeNode,
} from "node-library/dist/portal";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Card, Divider } from "@mui/material";
import { NeutralColor, PrimaryColor } from "node-library/dist/colors";
import {
	BlackButton,
	CustomIconButton,
	DropdownButton,
	GreenButton,
} from "../../../common-components/button";
import { NavBar } from "../../../common-components/navbar";
import { EditIcon, UserIcon } from "../../../common-components/svgIcons";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import { getContentContainer } from "../../../helpers/containerHelper";

import {
	getAdditionalInfoValueDisplayText,
	getShortTurnaroundTime,
	getTurnaroundTimeBackgroundColor,
} from "../../../helpers/sampleHelper";

import {
	getTestStatusColors,
	getTestStatusTranslationText,
} from "../../../helpers/sampleInstanceHelper";

import CreateOrUpdateSpecificationReadingDrawer from "../../../common-components/drawers/createOrUpdateSpecificationReadingDrawer";
import { getBatchStatusTranslationString } from "../../../helpers/testBatchHelper";
import {
	getEnabledHierarchyNodeTree,
	renderTestNodeSummary,
} from "../../../helpers/testHierarchyHelper";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	user: FrontendUserInfo;
	instance: FrontendAdminViewSampleWithInstanceAndSpec;
	setInstance: React.Dispatch<
		React.SetStateAction<FrontendAdminViewSampleWithInstanceAndSpec | undefined>
	>;

	navigateToOrderDetailsPage: (
		orderId: string,
		fromPage: FrontendContentPage,
	) => void;
	goBackToPreviousPage: (reload: boolean) => void;
	specDirectories: Array<FrontendSampleSpecificationDirectory>;
}

export default function AdminInstanceDetailsContent(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const {
		company,
		setCompany,
		instance,
		setInstance,
		goBackToPreviousPage,
		user,
		specDirectories,
	} = props;

	//order updatable fields
	const [testStatus, setTestStatus] = useState<TestStatus>(
		instance.sampleTestInfo?.status as TestStatus,
	);

	const [registerTime, setRegisterTime] = useState<Date | undefined>(
		instance.inserted ? new Date(instance.inserted) : undefined,
	);
	const [loading, setLoading] = useState<boolean>(false);

	const dueDate: Date = instance.expectedCompletionTime as Date;

	const [completeTime, setCompleteTime] = useState<Date | undefined>(undefined);

	const [editStateTimeModalOpen, setEditStateTimeModalOpen] =
		useState<boolean>(false);

	const [readingDrawerOpen, setReadingDrawerOpen] = useState<boolean>(false);

	const testCategory: FrontendCompanyTestCategory =
		company.companyTestCategories.find((category) => {
			return instance.sample.testCategoryId == category.testCategoryId;
		}) as FrontendCompanyTestCategory;

	const instanceMatrix: FrontendCompanySampleMatrix | undefined =
		testCategory.sampleMatrices.find((matrix) => {
			return matrix.matrixId == instance.sample.matrixId;
		});

	const hierarchyNodeParentMap = new Map<
		string,
		FrontendCompanyTestHierarchyNode[]
	>();

	testCategory.hierarchyNodes.forEach((node) => {
		const parentId = node.parentNodeId || "root";
		if (!hierarchyNodeParentMap.has(parentId))
			hierarchyNodeParentMap.set(parentId, [node]);
		else {
			hierarchyNodeParentMap.get(parentId)!.push(node);
		}
	});

	// const isInAdminView: boolean = checkUserTypeMeetsRequirement(
	// 	user?.role as SystemRole,
	// 	SystemRole.ADMIN
	// );

	let statusString: string;
	let statusColor: {
		backgroundColor: string;
		borderColor: string;
		textColor: string;
	};
	let statusDescriptionString: string;

	statusString = getTestStatusTranslationText(testStatus, translation);
	// statusDescriptionString = getStatusDescriptionText(testStatus, translation);
	statusColor = getTestStatusColors(testStatus);

	const TATBackgroundColor: string = getTurnaroundTimeBackgroundColor(
		instance.sampleTestInfo?.turnaroundTime as TurnaroundTime,
	);

	//dates

	const packageReceivedDateStr: string = registerTime
		? formatCustomDate(registerTime)
		: "";

	const navbarItems: Array<{
		label: string;
		onClick: () => void;
		isCurrentItem: boolean;
	}> = [
		{
			label: translation("Instances"),
			onClick: () => goBackToPreviousPage(false),
			isCurrentItem: false,
		},
		{
			label: translation("Details"),
			onClick: () => {},
			isCurrentItem: true,
		},
	];

	let actionButtonOptions: Array<{
		key: string;
		onClick: () => void;
		icon: React.ReactNode;
		text: string;
		widthToShow?: number;
	}> = [];
	let keyActionOption: {
		key: string;
		onClick: () => void;
		children: any;
		disabled?: boolean;
	} = {
		key: "view-order",
		onClick: () => {
			props.navigateToOrderDetailsPage(
				instance.orderId,
				FrontendContentPage.INSTANCE_PAGE,
			);
		},
		children: translation("Vieworder"),
	};

	// switch (orderStatus) {
	// 	case OrderStatus.IN_PROGRESS:
	// 	case OrderStatus.COMPLETE:
	// 		actionButtonOptions = [
	// 			{
	// 				key: "view-coc",
	// 				onClick: () => {
	// 					viewOrderCOC(order);
	// 				},
	// 				widthToShow: 780,
	// 				icon: <COAIcon />,

	// 				text: translation("ChainOfCustody"),
	// 			},
	// 			{
	// 				key: "copy-instance-export-data",
	// 				onClick: () => {
	// 					copyInstanceExportData();
	// 				},
	// 				icon: <CopyIcon size={20} />,

	// 				text: translation("Copyexportdata"),
	// 			},

	// 			{
	// 				key: "view-add-reports",
	// 				onClick: () => {
	// 					goToOrderReportPage(order);
	// 				},
	// 				icon: <UploadIcon size={20} />,

	// 				text: translation("Uploadreports"),
	// 			},
	// 			{
	// 				key: "discard-order",
	// 				onClick: () => {
	// 					setProceedAction(() => () => deleteOrder(order));
	// 					setDiscardOrderConfirmOpen(true);
	// 				},
	// 				icon: <ClearIcon sx={{ fontSize: "20px" }} />,

	// 				text: translation("Discardorder"),
	// 			},
	// 		];
	// 		break;
	// }

	let actionButton: React.ReactNode = <></>;
	if (actionButtonOptions.length == 1) {
		actionButton = (
			<BlackButton
				id={"order-details-actionbutton"}
				buttonClassName={
					actionButtonOptions[0].widthToShow
						? "order-details-inprogress-action-button"
						: ""
				}
				onClick={(e) => {
					actionButtonOptions[0].onClick();
				}}
			>
				{actionButtonOptions[0].text}
			</BlackButton>
		);
	} else if (actionButtonOptions.length > 1) {
		actionButton = (
			<DropdownButton
				buttonColor="black"
				id={"order-details-actionbutton"}
				container={getContentContainer()}
				menuOptions={actionButtonOptions.map((option) => {
					return {
						...option,
						children: (
							<div className="icon-dropdown-menu-item">
								{option.icon}
								{option.text}
							</div>
						),
					};
				})}
				onClick={(e) => {}}
			>
				{translation("Actions")}
			</DropdownButton>
		);
	}

	const buttonPanel: React.ReactNode = (
		<div
			style={{
				display: "flex",
				gap: "5px",
				justifyContent: "center",
				flexWrap: "wrap",
			}}
		>
			{actionButton}

			<GreenButton
				id={"order-details-key-action-button"}
				onClick={keyActionOption.onClick}
				disabled={keyActionOption.disabled}
			>
				{keyActionOption.children}
			</GreenButton>
		</div>
	);

	const orderDetailsHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "10px",
				flexWrap: "wrap",
			}}
		>
			<div>
				<div style={{ marginLeft: "35px" }}>
					<NavBar items={navbarItems}></NavBar>
				</div>

				<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
					<CustomIconButton
						id="order-details-back-button"
						size="small"
						onClick={() => {
							goBackToPreviousPage(false);
						}}
						icon={<KeyboardArrowLeftIcon />}
					></CustomIconButton>

					<div
						className="typography-heading-01"
						style={{ display: "flex", alignItems: "center", gap: "5px" }}
					>
						{`${translation("Instance")} ${instance.sample.fullSampleId}`}

						<div
							className="typography-caption turnaround-time-box"
							style={{ backgroundColor: TATBackgroundColor }}
						>
							{getShortTurnaroundTime(
								instance.sampleTestInfo?.turnaroundTime as TurnaroundTime,
								translation,
							)}
						</div>
						{instance.isRetest ? (
							<div
								className="typography-caption turnaround-time-box"
								style={{ backgroundColor: TATBackgroundColor }}
							>
								{translation("Retest")}
							</div>
						) : (
							<></>
						)}
						{instance.isAdditionalTest ? (
							<div
								className="typography-caption turnaround-time-box"
								style={{ backgroundColor: TATBackgroundColor }}
							>
								{translation("Add")}
							</div>
						) : (
							<></>
						)}
					</div>
				</div>
			</div>
			{buttonPanel}
		</div>
	);

	const orderDetailsCardRow: React.ReactNode = (
		<div className="instance-details-card-row">
			<Card className="card-border-radius-14p card-medium-padding">
				<div className="order-details-header-card-content">
					<div>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								gap: "10px",
							}}
						>
							<div
								className="typography-body-01 typography-bold admin-sample-status-box"
								style={{
									backgroundColor: statusColor.backgroundColor,
									border: `1px solid ${statusColor.borderColor}`,
									color: statusColor.textColor,
									minWidth: "20%",
								}}
							>
								{statusString}
							</div>
							{
								<div
									style={{ cursor: "pointer" }}
									onClick={() => {
										setEditStateTimeModalOpen(true);
									}}
								>
									<EditIcon strokeColor={NeutralColor.NEUTRAL_GREY_950} />
								</div>
							}
						</div>
						{/* <div
							className="typography-caption"
							style={{ color: NeutralColor.NEUTRAL_GREY_500, marginTop: "5px" }}
						>
							{statusDescriptionString}
						</div> */}
					</div>
					<div>
						<div className="order-details-time-grid">
							<div className="order-details-time-grid-item">
								<div
									className="typography-caption"
									style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
								>
									{translation("PackageReceivedOn")}
								</div>
								<div className="typography-body-01 typography-bold">
									{packageReceivedDateStr
										? packageReceivedDateStr.split(" | ")[0]
										: "--"}
								</div>
								<div className="typography-caption">
									{packageReceivedDateStr
										? packageReceivedDateStr.split(" | ")[1]
										: ""}
								</div>
							</div>
							<Divider orientation="vertical" flexItem></Divider>

							<div className="order-details-time-grid-item">
								<div
									className="typography-caption"
									style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
								>
									{translation("CompletedOn")}
								</div>
								<div
									className="typography-body-01 typography-bold"
									style={{
										color: completeTime ? PrimaryColor.PRIMARY_500 : "black",
									}}
								>
									{completeTime
										? formatCustomDate(completeTime).split(" | ")[0]
										: "--"}
								</div>
							</div>
						</div>
						<Divider orientation="horizontal" flexItem></Divider>
						<div>
							<div className="order-details-time-grid-item">
								<div
									className="typography-caption"
									style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
								>
									{translation("EstimatedCompletionDate")}
								</div>
								<div className="order-details-eta-time-grid">
									{
										<div>
											<div
												className="typography-caption turnaround-time-box"
												style={{
													backgroundColor: TATBackgroundColor,
													width: "fit-content",
												}}
											>
												{getShortTurnaroundTime(
													instance.sampleTestInfo
														?.turnaroundTime as TurnaroundTime,
													translation,
												)}
											</div>
											<div className="typography-body-01">
												{instance.expectedCompletionTime
													? formatAbsoluteDate(instance.expectedCompletionTime)
													: "--"}
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Card>
			<Card className="card-border-radius-14p card-medium-padding">
				<div>
					<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
						<div className="order-details-header-icon-container">
							<UserIcon
								strokeColor={PrimaryColor.PRIMARY_500}
								fillColor={PrimaryColor.PRIMARY_500}
							></UserIcon>
						</div>
						<div className="typography-body-01 typography-bold">
							{translation("SampleDetails")}
						</div>
					</div>

					<div
						style={{
							marginTop: "30px",
							display: "flex",
							flexDirection: "column",
							gap: "10px",
						}}
					>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("SampleId")}
							</div>
							<div className="order-details-info-row-info">
								{instance.sample.fullSampleId}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("SampleCategory")}
							</div>
							<div className="order-details-info-row-info">
								{testCategory.testCategoryName}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("OrderId")}
							</div>
							<div className="order-details-info-row-info">
								{instance.barcodeId}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("Matrix")}
							</div>
							<div className="order-details-info-row-info">
								{`${instanceMatrix?.matrix}`}
							</div>
						</div>
						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("LotCode")}
							</div>
							<div className="order-details-info-row-info">
								{instance.sample.lotCode}
							</div>
						</div>
						{instance.sample.sampleDescription && (
							<div className="order-details-user-info-row typography-body-02">
								<div className="order-details-user-info-row-title">
									{translation("SampleDescription")}
								</div>
								<div className="order-details-info-row-info wrap-text">
									{instance.sample.sampleDescription}
								</div>
							</div>
						)}

						{instance.sample.sampleAdditionalInfos.map((info) => {
							return (
								<div className="order-cell-body-row typography-body-02">
									<div className="order-details-user-info-row-title">{`${info.additionalFieldName} `}</div>
									<div className="order-details-info-row-info">
										{getAdditionalInfoValueDisplayText(info)}
									</div>
								</div>
							);
						})}
						{instance.sampleInstanceAdditionalInfos.map((info) => {
							return (
								<div className="order-cell-body-row typography-body-02">
									<div className="order-details-user-info-row-title">{`${info.additionalFieldName} `}</div>
									<div className="order-details-info-row-info">
										{getAdditionalInfoValueDisplayText(info)}
									</div>
								</div>
							);
						})}

						<div className="order-details-user-info-row typography-body-02">
							<div className="order-details-user-info-row-title">
								{translation("Client")}
							</div>
							<div className="order-details-info-row-info">
								{instance.clientCompanyName}
							</div>
						</div>
						{instance.specification && (
							<div className="order-details-user-info-row typography-body-02">
								<div className="order-details-user-info-row-title">{`${translation(
									"Specification",
								)}: `}</div>
								<div
									className="order-details-info-row-info overflow-ellipsis-text link-like-text"
									onClick={() => {
										if (instance.specification) {
											setReadingDrawerOpen(true);
										}
									}}
								>
									{`${instance.specification.fileName}.${instance.specification.format}`}
								</div>
							</div>
						)}
					</div>
				</div>
			</Card>
		</div>
	);

	function getBatchAdditionalInfoNode(
		matchingBatch: FrontendSampleTestBatch,
	): React.ReactNode {
		return (
			<div>
				<div>
					{`${translation("BatchId")}: ${matchingBatch.batchShortCode}${
						matchingBatch.batchFullCode
					}`}
				</div>

				<div>
					{`${translation("BatchCreatedOn")}: ${formatCustomDate(
						matchingBatch.inserted as Date,
					)}`}
				</div>
				<div>
					{`${translation("CompletedOn")}: ${
						matchingBatch.completeTime
							? formatCustomDate(matchingBatch.completeTime)
							: "--"
					}`}
				</div>
			</div>
		);
	}

	const testNodeIds: Array<string> =
		instance.sampleTestInfo?.selectedTests.map((test) => {
			return test.selectedNodeId;
		}) || [];
	const hierarchyTreeRootNode: TestHierarchyTreeNode =
		getEnabledHierarchyNodeTree(testNodeIds, hierarchyNodeParentMap);

	const testOptionBatchNodes: Array<React.ReactNode> =
		hierarchyTreeRootNode.children
			.filter((group) => group.nodeType === TestHierarchyNodeType.TEST_GROUP)
			.flatMap((group) => {
				const components: React.ReactNode[] = [];

				// Render selected TESTs

				for (const child of group.children) {
					if (child.nodeType === TestHierarchyNodeType.TEST) {
						const batchInfo: FrontendSampleTestBatch | undefined =
							instance.sampleTestInfo?.selectedTests.find((test) => {
								return test.selectedNodeId == child.nodeId;
							})?.assignedBatch;

						const testStatusText: string = batchInfo
							? getBatchStatusTranslationString(
									batchInfo.batchStatus,
									translation,
								)
							: translation("Unstarted");
						let additionalInfoNode: React.ReactNode = <></>;
						if (batchInfo) {
							additionalInfoNode = getBatchAdditionalInfoNode(batchInfo);
						}

						components.push(
							<div key={child.nodeId}>
								<div>
									{renderTestNodeSummary(child)}
									<div>{`${translation("Status")}: ${testStatusText}`}</div>
									{additionalInfoNode}
								</div>
							</div>,
						);
					}
				}

				return components;

				// Render the key of each true value
			}) || [];

	const otherTestBatch: FrontendSampleTestBatch | undefined =
		instance.sampleTestInfo?.additionalTestBatch;
	let otherTestNode: React.ReactNode = <></>;
	if (otherTestBatch) {
		const testStatusText = getBatchStatusTranslationString(
			otherTestBatch.batchStatus,
			translation,
		);
		const additionalInfoNode = getBatchAdditionalInfoNode(otherTestBatch);
		otherTestNode = (
			<div>
				{`${translation("OtherTest")}: ${
					(instance.sampleTestInfo as FrontendSampleTestInformation)
						.additionalTestDescription
				}`}
				<div>{`${translation("Status")}: ${testStatusText}`}</div>
				{additionalInfoNode}
			</div>
		);
	} else if (instance.sampleTestInfo?.additionalTest) {
		//batch is not created yet
		otherTestNode = (
			<div>
				{`${translation("OtherTest")}: ${
					instance.sampleTestInfo.additionalTestDescription
				}`}
				<div>{`${translation("Status")}: ${translation("Unstarted")}`}</div>
			</div>
		);
	}

	const instantTestBatchBody: React.ReactNode = (
		<div className="order-details-body">
			{testOptionBatchNodes} {otherTestNode}
		</div>
	);

	return (
		<div style={{ margin: "0 auto" }}>
			<div>
				{orderDetailsHeaderRow}
				{orderDetailsCardRow}

				{instantTestBatchBody}

				{/* <EditOrderStateTimeModal
					orderId={order.orderId}
					open={editStateTimeModalOpen}
					setOpen={setEditStateTimeModalOpen}
					orderStatus={orderStatus}
					setOrderStatus={setOrderStatus}
					completeTime={completeTime}
					setCompleteTime={setCompleteTime}
					refreshSelectedOrder={props.refreshSelectedOrder}
				></EditOrderStateTimeModal> */}
				{readingDrawerOpen && instance.specification && (
					<CreateOrUpdateSpecificationReadingDrawer
						company={company}
						setCompany={setCompany}
						testCategory={testCategory}
						// Derive matrix from the sample associated with the spec
						selectedMatrix={instanceMatrix as FrontendCompanySampleMatrix}
						selectedSpecFile={instance.specification}
						user={user}
						open={readingDrawerOpen}
						setOpen={setReadingDrawerOpen}
						specDirectories={specDirectories}
						updateSpecification={(spec: FrontendSampleSpecification) =>
							setInstance({ ...instance, specification: spec })
						}
					/>
				)}
			</div>
		</div>
	);
}
